<script lang="ts">
import {defineComponent} from 'vue'
import axios from "axios";

import vSelect from 'vue-select'
import {toast} from "vue3-toastify";
import moment from "moment";
import OjPagination from "../OjPagination.vue";
import LessonInstance from "@/components/onlajnovka/lesson-instance.vue";

/*
* nová sekce Lekce
stejné jako u KK v sekci lekce se všemi funkcemi - jediné co, tak uvidí tyto sloupce:
- WHEN - datum kdy se uskutečnila lekce - zadává lektor
- LECTURER - jméno lektora
- PRODUCT - produkt Onlajnovky
- COSTS - bere ze sekce Lektoři z kolonky sazba Onlajnovka 45 min, částka se zobrazí až po schválení adminem
- STATUS - defaultně inserted
- pak palce nahoru (approved) a dolu (denied), tužtička a koš
stejné jako u KK nahoře filtr podle data, lektora a statusu
možnost vybrat všechny vyfiltrované lekce a všechny hromadně schvhálit - approved (jako u KK
po schválení zobrazit částku u COST a dole pod všemi vyfiltrovanými lekcemi sečíst COSTS do sumy
mít tam taky počítadlo - zobrazeno 8 z 8 lekcí (ať víme kolik lekcí na stránce se zobrazuje)
*/
export default defineComponent({
  name: "past-lessons",
  props: ['admin', 'currentuser'],
  components:{LessonInstance,  OjPagination, vSelect, },
  created() {
    const lector = parseInt( window.localStorage.getItem('onlajnovka_lessons_lector_id') )
    this.filter_status = window.localStorage.getItem('onlajnovka_lessons_status')
    axios.get('/conversation-clubs/lectors.json',{ params:{

        per: 1000
      }}).then(r2 => {
      this.lectors = r2.data.items
      if (lector>0){
        for(let i in this.lectors){
          if (this.lectors[i].id == lector) this.selected_lector = this.lectors[i]
        }
      }

      this.loadSemesters()
      this.loadLessons()
      this.onLectorSearch('')
    })
  },
  data() {
    return {
      selectall: false,
      d1: null,
      d2: null,
      lectors: [],
      filtered_lectors: [],
      selected_lector: null,
      filter_status: '',
      is_admin: true,
      lesson_instances:[],
      current_instance:{onlajnovka_lesson:{}},
      total:0,
      per:20,
      page:1,
      paginationkey:0,
      sum_costs: 0,
      hh:0,
      semesters:[],
      current_semester:null,
    }
  },
  watch:{
    d1(){
      this.loadLessons()
    },
    d2(){
      this.loadLessons()
    },
    selected_lector(){
      this.loadLessons()
    },
    filter_status(){
      this.loadLessons()
    },
    current_semester(){
      this.loadLessons()
    },

    selectall(){

      for(let i in this.lesson_instances){
        this.lesson_instances[i].selected = this.selectall
      }
      this.selected_ids()
    }


  },
  methods:{
    formatedDate(d){
      return moment(d).format('D.M.YYYY')
    },


    setStatus(l,value){

        axios.put(`/onlajnovka/lesson-instances/${l.id}/set-status.json`, {status: value}).then(re=>{
          if (re.status===200){
            this.loadLessons()
            toast.success("Status lekce změněn")
          }
        }).catch(e=>{
          toast.error("Chyba při změně statusu lekce: "+e.response.data.message)
        })


    },


    loadLessons(){
      const params = {d1: null, d2: null, lector_id: null, status: null,semester_id: null, page: this.page, per: this.per}
      if (this.d1) params.d1 = this.d1
      if (this.d2) params.d2 = this.d2
      if (this.selected_lector) params.lector_id = this.selected_lector.id
      if (this.filter_status) params.status = this.filter_status
      if (this.current_semester) params.semester_id = this.current_semester

      window.localStorage.setItem('onlajnovka_lessons_lector_id', this.selected_lector ? this.selected_lector.id : '')
      window.localStorage.setItem('onlajnovka_lessons_status', this.filter_status)

      axios.get('/onlajnovka/lesson-instances.json', {params: params}).then(re=>{
        this.lesson_instances = re.data.items
        for(let i in this.lesson_instances){
          this.lesson_instances[i].selected = false
        }
        this.total = re.data.total
        this.paginationkey++
        this.sum_costs = re.data.sum_costs

        this.selectall = false
      }).catch(e=>{
        toast.error("Chyba při načítání lekcí: ")
      })

    },
    onLectorSearch(search){
      const s = search.toLowerCase()
      if (search==null || search=="") this.filtered_lectors = this.lectors

      this.filtered_lectors=[]

      for(let i in this.lectors){

        const l = this.lectors[i]
        const str = `${l.first_name.toLowerCase()} ${l.last_name.toLowerCase()}`
        if (str.indexOf(s)>=0)
          this.filtered_lectors.push(l)
      }

    },
    editLessonInstance(l){
      this.current_instance = l
      this.$refs.lessonInstance.showModal()
    },
    pageChanged(p){
      this.page=p
      this.loadLessons()
    },
    deleteLessonInstance(l){
      if (confirm("Opravdu smazat lekci "+l.lesson_name+" dne "+moment(l.when).format('D.M.YYYY')+"?")){
        axios.delete(`/onlajnovka/lesson-instances/${l.id}.json`).then(re=>{
          if (re.status===200){
            this.loadLessons()
            toast.success("Lekce smazána")
          }
        }).catch(e=>{
          toast.error("Chyba při mazání lekce: "+e.response.data.message)
        })
      }
    },

    onSelectedCbChanged(){

      this.selected_ids()

    },
    selected_ids(){
      let arr = []
      for(let i in this.lesson_instances){
        if (this.lesson_instances[i].status=='denied') continue

        if (this.lesson_instances[i].selected){
          arr.push(this.lesson_instances[i].id)
        }
      }
      this.hh = arr.length
      return arr
    },
    batchApprove(){
      const ids = this.selected_ids()
      if (ids.length==0){
        toast.error("Nevybrali jste žádné lekce")
        return
      }
      if (confirm(`Opravdu schválit ${ids.length} lekcí?`)){
        axios.put('/onlajnovka/lesson-instances/batch-approve.json', {ids: ids}).then(re=>{
          if (re.status===200){
            this.loadLessons()
            toast.success("Lekce schváleny")
          }
        }).catch(e=>{
          toast.error("Chyba při schvalování lekcí: "+e.response.data.message)
        })
      }

    },
    loadSemesters(){
      axios.get('/onlajnovka/semesters.json').then((response)=>{
        this.semesters = response.data.items
        this.current_semester = response.data.current.id

      })
    }

  }
})
</script>

<template>
<div class="card card-body">
  Lekce


  <div class="filtr d-flex">
    <div class="input-group">
      <div class="input-group-prepend">
        <span class="input-group-text">datum od </span>
      </div>
      <input type="date" class="form-control" v-model="d1"/>
    </div>

    <div class="input-group ml-2">
      <div class="input-group-prepend">
        <span class="input-group-text">do </span>
      </div>
      <input type="date" class="form-control " v-model="d2"/>
    </div>


    <div class="input-group ml-2" v-if="admin">
      <v-select v-model="selected_lector" @search="onLectorSearch" :filterable="false" :options="filtered_lectors" :disabled="!is_admin"  style="width: 350px">

        <template #option="option">
          <div class="d-center row">
            <div class="col-1">
              <img :src="option.profile_image_url" v-if="option.profile_image_url" class="icoproduct">
            </div>
            <div class="col-6">{{ option.first_name }} {{ option.last_name }}</div>
          </div>
        </template>
        <template #selected-option="option">
          <div class="selected d-center">
            <img :src="option.profile_image_url" v-if="option.profile_image_url" class="icoproduct"> {{ option.first_name }} {{ option.last_name }}
          </div>
        </template>
      </v-select>
    </div>

    <div class="input-group ml-2" >
      <select class="form-control" v-model="filter_status">
        <option value="all">Všechny statusy</option>
        <option value="inserted">inserted</option>
        <option value="approved">approved</option>
        <option value="denied">denied</option>

      </select>
    </div>

    <div class="input-group ml-2" >
      <select class="form-control" v-model="current_semester">
        <option value="*">Všechny semestry</option>
        <option v-for="s in semesters" :key="s.id" :value="s.id">{{s.name}}</option>
      </select>
    </div>




  </div>


<div class="d-flex mb-2" v-if="hh>0">
    <div class="col" >
      HROMADNÉ AKCE (vybráno {{hh}}):  <button class=" btn  btn-success " @click.prevent="batchApprove">schválení</button>
     </div>
  </div>


  <div class="d-flex">
    <OjPagination
        :key="paginationkey+1"
        class="m-auto"
        :totalItems="total"
        :currentPage="page"
        :perPage="per"
        @pageChanged="pageChanged" />


    <div>zobrazeno {{lesson_instances.length}} z {{total}} lekcí.</div>

  </div>


<table class="table table-bordered">
  <thead>
    <tr>
      <th v-if="admin"><input type="checkbox" v-model="selectall"   /></th>
      <th>WHEN </th>
      <th>LECTURER</th>
      <th colspan="2">PRODUCT</th>
      <th>Description</th>
      <th>COSTS</th>
      <th>STATUS</th>
      <th>AKCE</th>
    </tr>
  </thead>
  <tbody>
    <tr v-for="l in lesson_instances" :key="l.id">
      <td v-if="admin"><input type="checkbox" v-model="l.selected"  @change="onSelectedCbChanged" v-if="l.status!='denied'"/></td>
      <td>{{ formatedDate(l.when) }}</td>
      <td>{{ l.lector_name }}</td>
      <td>{{ l.product_name }}  </td>
      <td>{{l.lesson_name }}</td>

      <td>{{l.description}}</td>


      <td>{{ l.costs }}</td>
      <td>{{ l.status }}</td>
      <td class="actions">

        <a  href="#" title="schválit" v-if="l.status=='inserted' && admin" @click.prevent="setStatus(l,'approved')"><span class="material-icons-outlined">thumb_up</span></a>
        <a  href="#" title="zamítnout" v-if="l.status=='inserted' && admin" @click.prevent="setStatus(l,'denied')"><span class="material-icons-outlined">thumb_down</span></a>
        <a v-if="admin || l.status==='inserted'" href="#" title="upravit" @click.prevent="editLessonInstance(l)"><span class="material-icons-outlined">mode_edit_outline</span></a>
        <a v-if="admin || l.status==='inserted'" href="#" title="smazat" @click.prevent="deleteLessonInstance(l)"><span class="material-icons-outlined mazani">delete</span></a>

      </td>
    </tr>
    <tr v-if="false">
      <td colspan="7">Zobrazeno 8 z 8 lekcí, celkem 1234 CZK</td>
    </tr>

  </tbody>

</table>
<div class="row sumarow">
    <div class="col-md-9 sumarowcol">
        SUMA z vyfiltrovaných COSTS
    </div>
    <div class="col-md-2 sumarowcol ">
      {{sum_costs}}
    </div>
  </div>



</div>

  <lesson-instance ref="lessonInstance"
                   :lesson="current_instance.onlajnovka_lesson"
                   :instance="current_instance"
                   :current_user="currentuser"
                    :admin="admin"
                   @lessonSaved="loadLessons"

  ></lesson-instance>

</template>

<style scoped>
.miniico{
  height: 30px;
  border-radius: 14px; margin-right: 30px;
}
.icoproduct{
  max-height: 20px;
}
.filtr{
  margin-bottom: 15px;
}

.actions a {
  margin-right: 10px;

}

</style>